import type { CSSProperties } from 'react';
import { radius } from '../../theme/tokens';
import { Block } from './SkeletonBlock.styles';
import type { SkeletonBlockProps } from './SkeletonBlock.types';

const VARIANT_STYLES: Record<
  NonNullable<SkeletonBlockProps['variant']>,
  { width: string; height: string; borderRadius?: string }
> = {
  text: { width: '100%', height: '1rem' },
  heading: { width: '60%', height: '1.75rem' },
  button: { width: '100%', height: '48px', borderRadius: radius('button', 'radius-xl') },
  image: { width: '100%', height: '300px' },
};

export function SkeletonBlock({ variant, width, height, borderRadius }: SkeletonBlockProps) {
  const variantDefaults = variant ? VARIANT_STYLES[variant] : undefined;

  const style: CSSProperties = {
    width: width ?? variantDefaults?.width ?? '100%',
    height: height ?? variantDefaults?.height ?? '1rem',
    ...(borderRadius || variantDefaults?.borderRadius
      ? { borderRadius: borderRadius ?? variantDefaults?.borderRadius }
      : {}),
  };

  return <Block style={style} aria-hidden="true" />;
}
